// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-calendar-container {
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.request-calendar-container .grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.request-calendar-container .grid .details {
  grid-area: 1/1/2/2;
}
.request-calendar-container .grid .calendar {
  grid-area: 1/2/2/6;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .request-calendar-container {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid .details {
    position: absolute;
    background-color: white;
    height: calc(100vh - 80px);
    width: 285px;
    z-index: 9;
    left: -285px;
    transition: 0.5s ease-in-out;
  }
  .request-calendar-container .grid .details.show {
    left: 0;
  }
  .request-calendar-container .grid .calendar {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid .calendar .request-calendar {
    width: 100%;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .request-calendar-container {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid .details {
    position: absolute;
    background-color: white;
    height: calc(100vh - 80px);
    width: 285px;
    z-index: 9;
    left: -285px;
    transition: 0.5s ease-in-out;
  }
  .request-calendar-container .grid .details.show {
    left: 0;
  }
  .request-calendar-container .grid .calendar {
    display: flex;
    width: 100vw;
  }
  .request-calendar-container .grid .calendar .request-calendar {
    width: 100%;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .request-calendar-container .grid .details {
    height: calc(100vh - 80px);
    width: 100%;
    left: -100%;
    transition: 0.8s ease-in-out;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/Calendar/calendar.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA,EAAA,oBAAA;AADJ;AAGI;EACI,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AADR;AAGQ;EACI,kBAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAOI;EACI;IACI,UAAA;EALV;EAQM;IACI,UAAA;EANV;AACF;AASI;EACI;IACI,UAAA;EAPV;EAUM;IACI,UAAA;EARV;AACF;;ACvBY;EDqCR;IACI,aAAA;IACA,YAAA;EAVN;EAWM;IACI,aAAA;IACA,YAAA;EATV;EAUU;IACI,kBAAA;IACA,uBAAA;IACA,0BAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;IACA,4BAAA;EARd;EASc;IACI,OAAA;EAPlB;EAUU;IACI,aAAA;IACA,YAAA;EARd;EASc;IACI,WAAA;EAPlB;AACF;AC5DY;ED4CR;IACI,aAAA;IACA,YAAA;EAmBN;EAlBM;IACI,aAAA;IACA,YAAA;EAoBV;EAnBU;IACI,kBAAA;IACA,uBAAA;IACA,0BAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;IACA,4BAAA;EAqBd;EApBc;IACI,OAAA;EAsBlB;EAnBU;IACI,aAAA;IACA,YAAA;EAqBd;EApBc;IACI,WAAA;EAsBlB;AACF;ACzFY;ED4EA;IACI,0BAAA;IACA,WAAA;IACA,WAAA;IACA,4BAAA;EAgBd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.request-calendar-container {\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n\n    .grid {\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n        grid-template-rows: 1fr;\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n\n        .details {\n            grid-area: 1 / 1 / 2 / 2;\n        }\n\n        .calendar {\n            grid-area: 1 / 2 / 2 / 6;\n        }\n    }\n\n\n    @keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n\n        100% {\n            opacity: 0;\n        }\n    }\n}\n\n\n@include media(tablet, mobile) {\n    .request-calendar-container {\n        display: flex;\n        width: 100vw;\n        .grid {\n            display: flex;\n            width: 100vw;\n            .details {\n                position: absolute;\n                background-color: white;\n                height: calc(100vh - 80px);\n                width: 285px;\n                z-index: 9;\n                left: -285px;\n                transition: .5s ease-in-out;\n                &.show {\n                    left: 0;\n                }\n            }\n            .calendar {\n                display: flex;\n                width: 100vw;\n                .request-calendar {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .request-calendar-container {\n        .grid {\n            .details {\n                height: calc(100vh - 80px);\n                width: 100%;\n                left: -100%;\n                transition: .8s ease-in-out;\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
